import React from 'react'
import { TableBodyRow, TableHead } from '../../../../../widget/styledComponents/table.style';
import {  Dialog, MoreIcon, Pagination, Pane, Spinner,toaster } from 'evergreen-ui';
import { FieldBtn, GuestListTableContainer } from '../../dues/dues.style';
import { gql, useMutation, useQuery } from '@apollo/client';
import { useState } from 'react';
import Cookies from 'js-cookie';
import { AppInputField, AppInputFieldBtn, AppInputFieldBtnCancel, InputFieldTitleText } from '../../../../../widget/styledComponents/input_field.style';
import { capitalizeFirstLetterOfWords } from '../../../../../widget/util';
import DeleteDebtButton from '../widget/delete_debt_btn';
import EditDebtButton from '../widget/edit_debt';

export const FETCH_DEBT_LIST = gql`
query Debts_getByProperty($propertyId: ID!) {
  debts_getByProperty(propertyId: $propertyId) {
    _id
    property
    title
    amount
    status
    paidOn
    paidBy
    paidByType
    startDate
    endDate
    createdAt
  }
}
`;
function Debt(props) {
  const property = props.details

  const { loading,data }  = useQuery(FETCH_DEBT_LIST,{
      variables: {
        propertyId:property._id,
      },
  });
  

  return (
    <div>
        
        <div className=''>
            <br/>
            <GuestListTableContainer>
               
                <table className='responsive-table'>
                    <thead>
                    <tr
                    >
                        <TableHead>Title</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Start Date</TableHead>
                        <TableHead>End Date</TableHead>
                        <TableHead>
                          <MoreIcon />
                        </TableHead>
  
                    </tr>
                    </thead>
  
                    <tbody>
                        {loading && <Spinner/> }
                        {data &&
                        
                        data.debts_getByProperty.map((data) => 
                            <TableBodyRow
                            >
                                <td>{capitalizeFirstLetterOfWords(data.title)}</td>
                                <td>N{data.amount}</td>
                                <td>{data.startDate}</td>
                                <td>{data.endDate}</td>
                                <td>
                                  {/* <IconButton
                                     onClick={()=>{
                                    }}
                                  icon={MoreIcon} intent="primary"  /> */}
                                  <DeleteDebtButton debtId={data._id} />
                                  <EditDebtButton
                                    debtId={data._id}
                                    title={data.title}
                                    amount={data.amount}
                                    startDate={data.startDate}
                                    endDate={data.endDate}
                                  />
                                </td>
                              
                            </TableBodyRow>
                            )
                        }
                      
                    </tbody>
                </table>
                <Pagination className='transparent z-depth-0' 
                totalPages={4} 
                 
                ></Pagination>             
            </GuestListTableContainer>

            <br/>
            <center>
             <AddDebt property={property}/>
            </center>
        </div>
    </div>
  )
}

export default Debt







export const ADD_DEBT = gql`
mutation Debt_create($propertyId: ID!, $title: String!, $amount: Float!, $startDate: Date!, $endDate: Date!) {
  debt_create(propertyId: $propertyId, title: $title, amount: $amount, startDate: $startDate, endDate: $endDate) {
    createdAt
    amount
    _id
  }
}
`;


function AddDebt(props) {
  const property = props.property
  const accesTokenValue = Cookies.get('userAccessToken');
  const [addDebt, { loading }] = useMutation(ADD_DEBT);
// const [checked, setChecked] = React.useState(false)

  const [isShown, setIsShown] = React.useState(false)
  const [dataObject, setDataObject] = useState({
    propertyId: property._id,
  });
 
  
  const handleSubmit=(e)=>{
    e.preventDefault()
  
  
    console.log(dataObject)
    
    addDebt({
      variables:dataObject,
      context: {
        headers: {
          Authorization: `Bearer ${accesTokenValue}`,
        },
      },
    })
    .then((response) => {
      toaster.success("Debt added successfully.")
      window.location.reload()
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }



 
  
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let va = value
      if(name==="amount"){
        va = parseFloat(value)
        let floatValue = va.toFixed(1);
        console.log("save as flit",typeof floatValue)
        va = parseFloat(floatValue)
        console.log("save as flit",typeof va)
      }
      setDataObject({
        ...dataObject,
        [name]: va
      });
    
  };

// const handleSelectionChange = (name='',option) => {
//     console.log("name-===",name)
//     console.log("value==",option)
//     setDataObject({
//       ...dataObject,
//       [name]: option
//     });
// };
      return (
            <Pane>
              <Dialog
                isShown={isShown}
                title="Create a New Debt"
                onCloseComplete={() => setIsShown(false)}
                hasHeader={true}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEscapePress={false}
                hasFooter ={false}
              >
                  
                 
                  <div className=''>
                  <div>
                  <form onSubmit={handleSubmit}>
                  {/* <form> */}
                      <div className='row'>
                            <div className='col s12 '>
                                  <InputFieldTitleText>
                                      title
                                  </InputFieldTitleText>
                                  <AppInputField
                                      type="text" 
                                      placholder=""
                                      name="title" // Change to the desired field name in the object
                                      onChange={handleInputChange}
                                  required/> 
                              </div>
                              <div className='col s12 '>
                                  <InputFieldTitleText>
                                      Amount
                                  </InputFieldTitleText>
                                  <AppInputField
                                      type="number" step="0.01"
                                      placholder=""
                                      name="amount" // Change to the desired field name in the object
                                      onChange={handleInputChange}
                                  required/> 
                              </div>
                              
                              
                              <div className='col s12 '>
                                <InputFieldTitleText>
                                Start Date
                                </InputFieldTitleText>
                                <AppInputField
                                    type="datetime-local" 
                                    name='startDate'
                                    placholder=""
                                    onChange={handleInputChange}
                                required/> 
                            </div>

                            <div className='col s12 '>
                                <InputFieldTitleText>
                                End Date
                                </InputFieldTitleText>
                                <AppInputField
                                    type="datetime-local" 
                                    name='endDate'
                                    placholder=""
                                    onChange={handleInputChange}
                                required/> 
                            </div>
                            
                              
                              
                            
                              <div className='row'>
                                  <div className='col s12 right' style={{
                                      display:"flex",
                                      flexWrap:"wrap",
                                      justifyContent:"end"
                                  }}>
                                       <div className='' style={{
                                          width:"120px",
                                      }}>
                                         <AppInputFieldBtnCancel 
                                          className='btn btn-flat center p-2'
                                          style={{
                                              background:"transparent !important"
                                          }} 
                                          onClick={() => setIsShown(false)}
                                        >
                                              Cancel
                                          </AppInputFieldBtnCancel >
                                      </div>

                                    
                                      <div className='' style={{
                                          width:"120px",
                                      }}>
                                          {loading  &&
                                          <center>
                                              <Spinner/>
                                          </center>
                                          }
                                          {!loading &&
                                              <AppInputFieldBtn className=''
                                              type="submit"
                                              disabled={loading}
                                            >
                                                  Add
                                            </AppInputFieldBtn>
                                          }
                                          
                                    </div>
                                  </div>
                              </div>
                          <br/>
                      </div>
                      </form>
                  </div>
                  </div>
              </Dialog>
              <div className=''>
                  <FieldBtn 
                   onClick={() => setIsShown(true)}
                  class="waves-effect waves-light btn-flat ">
                      <i class="material-icons left">add</i>
                      Add Debt
                  </FieldBtn>
              </div>
      
            </Pane>
          )
  }
  